<form [formGroup]="searchForm">
  <mat-form-field class="w-full">
    <mat-label>Search</mat-label>
    <input matInput formControlName="terms" (keyup)="search()"/>
    @if (!(searchActive$ | async)) {
      <app-icon matIconSuffix class="mr-2" icon="search"></app-icon>
    }
    @if (searchActive$ | async) {
      <app-icon matIconSuffix [spin]="true" class="mr-2" icon="spinner"></app-icon>
    }
  </mat-form-field>
  <mat-action-list>
    @for (result of searchResults$ | async; track result) {
      <mat-list-item (click)="resultClick(result)">
        <div matListItemTitle>
          <span class="number">{{ result.caption }}</span>
          <span class="date ml-2">{{ result.shipment.shipmentDate }}</span>
        </div>
        @if (!!result.shipment.trackingNumber) {
          <div matListItemLine>
            <span class="courier">{{ result.shipment.courierModule }}</span>
            <span class="tracking ml-2">{{ result.shipment.trackingNumber }}</span>
          </div>
        }
        <div matListItemLine>
          <span class="organization">{{ result.shipment.destination.organization }}, </span>
          <span class="city ml-1">{{ result.shipment.destination.city }}, </span>
          <span class="country ml-1">{{ result.shipment.destination.country }}</span>
        </div>
      </mat-list-item>
    }
  </mat-action-list>
</form>
